// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integrationNavigation {
    width: 256px;
    background-color: #0F3443;
    height: 100%;
    overflow: hidden;
    padding: 16px;
}

.integrationLogo {
    margin: 10px 72px 132px 10px;
}

.userMenuImage {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    margin-right: 5px;
}

.userInfos {
    justify-content: space-evenly;
}

.integrationUser {
    color: white;
}

.integrationDisplayName {
    font-size: 12px;
}

.integrationProfileText {
    font-size: 10px;
}

.integrationMenuEntry {
    color: white;
    height: 40px;
    font-size: 15px;
    font-family: Segoe UI;
    border-radius: 6px;
}

    .integrationMenuEntry:hover {
        background-color: #686868;
    }

    .integrationMenuEntry.customselected {
        background-color: var(--integration-background);
        color: #0F3443;
    }

.iconcls {
    height: 18px;
    width: 18px;
    margin-left: 5%;
}

.intspancls {
    justify-content: center;
    justify-content: left;
    margin-left: 10px;
}

.integrationInnerContent > * {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pages/integration.page.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,+CAA+C;QAC/C,cAAc;IAClB;;AAEJ;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".integrationNavigation {\n    width: 256px;\n    background-color: #0F3443;\n    height: 100%;\n    overflow: hidden;\n    padding: 16px;\n}\n\n.integrationLogo {\n    margin: 10px 72px 132px 10px;\n}\n\n.userMenuImage {\n    height: 36px;\n    width: 36px;\n    border-radius: 50%;\n    margin-right: 5px;\n}\n\n.userInfos {\n    justify-content: space-evenly;\n}\n\n.integrationUser {\n    color: white;\n}\n\n.integrationDisplayName {\n    font-size: 12px;\n}\n\n.integrationProfileText {\n    font-size: 10px;\n}\n\n.integrationMenuEntry {\n    color: white;\n    height: 40px;\n    font-size: 15px;\n    font-family: Segoe UI;\n    border-radius: 6px;\n}\n\n    .integrationMenuEntry:hover {\n        background-color: #686868;\n    }\n\n    .integrationMenuEntry.customselected {\n        background-color: var(--integration-background);\n        color: #0F3443;\n    }\n\n.iconcls {\n    height: 18px;\n    width: 18px;\n    margin-left: 5%;\n}\n\n.intspancls {\n    justify-content: center;\n    justify-content: left;\n    margin-left: 10px;\n}\n\n.integrationInnerContent > * {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
